import React from "react";
import classNames from "classnames";
import { NavLink, Forbidden } from "MODULES/shared/components";
import { authorized } from "MODULES/shared/decorators";
import {
  CAN_ADD_COMPANIES,
  CAN_UPDATE_COMPANIES,
  ROLES,
  WAREHOUSE,
  WAREHOUSE_BASIC,
  WAREHOUSE_EXPERT,
  WAREHOUSE_LOGISTICS_DIRECTOR
} from "MODULES/users/constants";
import Authorized from "MODULES/shared/components/Authorized";
import { without } from "lodash";
import lotSvg from "APP_ASSETS/images/lot.svg";
import lotWhiteSvg from "APP_ASSETS/images/lot_white.svg";
import { useCurrentUser } from "APP_ROOT/hooks";
import { withRouter } from "react-router-dom";

const UsersLink = authorized()(() => (
  <NavLink path="/users" icon="fa-users" title="Users" listId="users" />
));

function Sidebar(props) {
  const currentUser = useCurrentUser();
  const sidebarClasses = classNames(
    "sidebar sidebar-default sidebar-inverse sidebar-padding-none",
    {
      development: ["staging", "development"].includes(process.env.NODE_ENV),
      "email-warning": currentUser && !currentUser.email_verified
    }
  );

  return (
    <div className={sidebarClasses}>
      <ul className="nav sidebar-nav">
        <NavLink path="/parts" icon="fa-cogs" title="Parts" listId="parts" />
        <Authorized
          roles={without(ROLES, WAREHOUSE)}
          subroles={[WAREHOUSE_LOGISTICS_DIRECTOR]}
        >
          <NavLink
            path="/incoming-quotes"
            icon="fa-quote-left"
            title="Incoming Quotes"
            listId="incomingQuotes"
          />
          <NavLink
            path="/outgoing-quotes"
            icon="fa-quote-right"
            title="Outgoing Quotes"
            listId="outgoingQuotes"
          />
        </Authorized>
        <Forbidden subroles={[WAREHOUSE_BASIC]}>
          <NavLink
            path="/purchase-orders"
            icon="fa-shopping-cart"
            title="Purchase Orders"
            listId="purchaseOrders"
          />
          <NavLink
            path="/sales-orders"
            icon="fa-dollar"
            title="Sales Orders"
            listId="salesOrders/search"
          />
          <NavLink
            path="/repair-orders"
            icon="fa-wrench"
            title="Repair Orders"
            listId="repairOrders"
          />
          <NavLink
            path="/managed-repair-orders"
            icon="fa-recycle"
            title="Managed Repair Orders"
            listId="managedRepairOrders"
          />
          <NavLink
            path="/lots"
            svg={
              props.location.pathname.includes("/lot") ? lotWhiteSvg : lotSvg
            }
            hoverSvg={lotWhiteSvg}
            icon="fa-lots"
            title="Lot Orders"
            listId="lots"
          />
          <NavLink
            path="/consignments"
            icon="fa-handshake-o"
            title="Consignments / EMA"
            listId="consignments"
          />
        </Forbidden>
        <Authorized
          roles={without(ROLES, WAREHOUSE)}
          subroles={[WAREHOUSE_LOGISTICS_DIRECTOR]}
        >
          <NavLink
            path="/vendor-rmas"
            icon="fa-shield"
            title="Vendor RMAs"
            listId="rmas"
          />
          <NavLink
            path="/customer-rmas"
            icon="fa-cog"
            title="Customer RMAs"
            listId="customerRmas"
          />
        </Authorized>
        <NavLink
          path="/receiving"
          icon="fa-truck"
          title="Received Orders"
          listId="receivingRecords"
        />
        <Authorized
          roles={without(ROLES, WAREHOUSE)}
          permissions={[CAN_ADD_COMPANIES, CAN_UPDATE_COMPANIES]}
          subroles={[WAREHOUSE_EXPERT, WAREHOUSE_LOGISTICS_DIRECTOR]}
        >
          <NavLink
            path="/companies"
            icon="fa-building"
            title="Companies"
            listId="companies"
          />
        </Authorized>
        <NavLink
          path="/shipping"
          icon="fa-external-link"
          title="Shipped Orders"
          listId="shipments"
        />
        <UsersLink />
        <NavLink
          path="/mistake-shipments"
          icon="fa-exclamation-triangle"
          title="Mistake Shipments"
          listId="mistakeShipments"
        />
        <NavLink
          path="/rejected-cores"
          icon="fa-refresh"
          title="Rejected Cores"
          listId="rejectedCores"
        />
      </ul>
    </div>
  );
}

export default withRouter(Sidebar);



// WEBPACK FOOTER //
// ./app/Sidebar/Sidebar.jsx